var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSplitTicketingVttStLcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 30,
    viewBox: "0 0 45 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#E10A0A",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.998 30 4-4.018H4.004v-3.765l6.433-6.46a1.075 1.075 0 0 0 0-1.514L4.003 7.784V4.018H29.88L33.881 0H4.003A4.01 4.01 0 0 0 0 4.018v5.426l4.78 4.798a1.075 1.075 0 0 1 0 1.515L0 20.556v5.426A4.01 4.01 0 0 0 3.998 30M41.002 0 11.12 30h29.878A4.01 4.01 0 0 0 45 25.982v-5.426l-4.78-4.799a1.075 1.075 0 0 1 0-1.514L45 9.444V4.018A4.01 4.01 0 0 0 41.002 0"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSplitTicketingVttStLcon);
export default __webpack_public_path__ + "static/media/icon-split-ticketing-vtt-st-lcon.0056963a375451d885674bd5ab4f78ca.svg";
export { ForwardRef as ReactComponent };